import type { TFunction } from 'i18next'

/**
 * Persona ilişkisinin türü (089 vekalet + 126 asistanlık). Birlik iki yerde satır içi yazılmıştı;
 * etiketleme buna dayandığı için burada adlandırıldı ve {@code proxyPersonaApi} de bunu kullanıyor.
 * {@code auth/useCurrentUser} bilinçle kendi satır içi yazımını koruyor — o alt katman, {@code
 * features/} klasöründen tip almamalı.
 */
export type PersonaKind = 'PROXY' | 'ASSISTANT_FULL' | 'ASSISTANT_LIMITED'

/**
 * Adın yanına yetki seviyesini ekleyen **tek** nokta (126 FR-015).
 *
 * <p>Üç yüzey aynı metni göstermek zorunda: persona menüsünün satırı, seçim sonrası üst bardaki
 * rozet ve (Kısıtlı kipte) uyarı şeridi. Her biri kendi `t(...)` çağrısını yazsaydı biri
 * güncellenip diğeri unutulurdu — kullanıcı o zaman menüde "(Tam Yetki)" görüp rozette
 * göremezdi (20.10.2026 bildirimi tam bu eksikti: rozet yalnız adı gösteriyordu).
 *
 * <p><b>Vekalet satırı çıplak kalır:</b> {@code PROXY} için ek yoktur. 089'un davranışı
 * değişmedi ve "Tam/Kısıtlı" ayrımı yalnız asistanlıkta anlamlı.
 */
export function personaLabelWithAuthority(
  t: TFunction,
  name: string,
  kind: PersonaKind | null | undefined,
): string {
  if (kind === 'ASSISTANT_LIMITED') {
    return t('proxy.select.asAssistantLimited', { name })
  }
  if (kind === 'ASSISTANT_FULL') {
    return t('proxy.select.asAssistantFull', { name })
  }
  return name
}
